import React from 'react';
import { Carousel } from 'antd';

import { carouselSlides } from '../../../data/carousel';

import {
  CarouselSection,
  SlideWrapper,
  SlideContent,
  SlideTitle,
  SlideSubtitle,
  SlideCTA,
} from '../styles';

export default function HeroCarousel() {
  return (
    <CarouselSection>
      <Carousel autoplay autoplaySpeed={5000} dots>
        {carouselSlides.map((slide) => (
          <div key={slide.id}>
            <SlideWrapper $bgColor={slide.bgColor}>
              <SlideContent>
                <SlideTitle $textColor={slide.textColor}>
                  {slide.title}
                </SlideTitle>
                <SlideSubtitle $textColor={slide.textColor}>
                  {slide.subtitle}
                </SlideSubtitle>
                <SlideCTA to={slide.buttonLink}>
                  {slide.buttonText}
                </SlideCTA>
              </SlideContent>
            </SlideWrapper>
          </div>
        ))}
      </Carousel>
    </CarouselSection>
  );
}
